export default __webpack_public_path__ + "static/ti-basque-d52322d21985a1a73db3bf10757b112b.jpg";